import { gql } from '@apollo/client'

export const tribesQuery = gql`
  query getTribes($getTribes: Boolean!, $isStudent: Boolean!) {
    getTribes(getTribes: $getTribes, isStudent: $isStudent) {
      id
      name
    }
  }
`

export const restrictionsQuery = gql`
  query getRestrictions($getRestrictions: Boolean!, $educationPeriod: Int!, $stateCd: String!) {
    getRestrictions(
      getRestrictions: $getRestrictions
      educationPeriod: $educationPeriod
      stateCd: $stateCd
    ) {
      restrictions
    }
  }
`
